var _defs, _circle, _line, _circle2, _line2, _line3, _path, _path2, _g, _rect, _polyline, _rect2, _line4, _line5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDecisionmakingstyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-6,.cls-7{fill:none;}.cls-2{fill:#f0f0f0;}.cls-3,.cls-6{stroke:#002554;}.cls-3,.cls-6,.cls-7{stroke-linecap:round;}.cls-3,.cls-7{stroke-linejoin:round;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#425cc7;}.cls-6{stroke-miterlimit:10;}.cls-7{stroke:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 8.34,
    width: 7.3,
    height: 7.26,
    rx: 1.92
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 16,
    r: 15.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.71,
    y1: 27.48,
    x2: 24.29,
    y2: 27.48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16,
    cy: 11.97,
    r: 3.64
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.31,
    y1: 27,
    x2: 20.31,
    y2: 20.59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.69,
    y1: 20.59,
    x2: 11.69,
    y2: 27.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.31,17a1.35,1.35,0,0,1,1,.47l3.29,3.76h3.3a1.4,1.4,0,0,1,0,2.8H24a1.42,1.42,0,0,1-1.05-.48l-2.59-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.31,17H11.69a1.35,1.35,0,0,0-1,.47L7.41,21.23H4.11a1.4,1.4,0,1,0,0,2.8H8.05a1.42,1.42,0,0,0,1-.48l2.59-3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2.9,
    y: 8.34,
    width: 7.3,
    height: 7.26,
    rx: 1.92
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2,
    y: 8.34,
    width: 7.3,
    height: 7.26,
    rx: 1.92
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "4.05 11.87 5.2 13.03 7.51 10.42"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 22.7,
    y: 8.34,
    width: 7.3,
    height: 7.26,
    rx: 1.92
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.68,
    y1: 10.64,
    x2: 25.01,
    y2: 13.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.68,
    y1: 13.3,
    x2: 25.01,
    y2: 10.64
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDecisionmakingstyle);
export default __webpack_public_path__ + "static/media/icon-decisionmakingstyle.2991bd0b751aa692da7bbe7b90ded368.svg";
export { ForwardRef as ReactComponent };